import styled from "@emotion/styled";
import MemLogomark from "@/assets/images/mem-logomark.svg";
import { SessionNotification } from "@/mds/components/sessions/session-notification";

type Props = {};

export const MDSSessionNotificationView: React.FC<Props> = () => {
  return (
    <Container>
      <img src={MemLogomark} alt="Mem logo" style={{ width: 22, height: 22, display: "block" }} />
      <MessageText>
        <SessionNotification />
      </MessageText>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) =>
    `${theme.spacing.md} ${theme.spacing.md} ${theme.spacing.sm} ${theme.spacing.md}`};
`;

const MessageText = styled.div`
  flex: 1;
  text-align: left;
  line-height: 1.4;
`;
